import React from 'react'
import store from '../../store/Store'
import routes from '../../routes/Routes'

import { Link, Redirect, withRouter } from 'react-router-dom'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

import actionTypes from '../../actionTypes/actionTypes'
import Actions from '../../actions/Actions'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'

import MenuIcon from '@material-ui/icons/Menu'
import HomeIcon from '@material-ui/icons/Home'
import QueueIcon from '@material-ui/icons/Queue'
import PersonIcon from '@material-ui/icons/Person'
import AssignmentIcon from '@material-ui/icons/Assignment'
import ArchiveOutlinedIcon from '@material-ui/icons/ArchiveOutlined'
import LanguageOutlinedIcon from '@material-ui/icons/LanguageOutlined'
import VerticalSplitOutlinedIcon from '@material-ui/icons/VerticalSplitOutlined'
import HorizontalSplitOutlinedIcon from '@material-ui/icons/HorizontalSplitOutlined'
import NavigationOutlinedIcon from '@material-ui/icons/NavigationOutlined'
import MergeTypeIcon from '@material-ui/icons/MergeType'
import BorderRightIcon from '@material-ui/icons/BorderRight'
import BorderLeftIcon from '@material-ui/icons/BorderLeft'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import BorderBottomIcon from '@material-ui/icons/BorderBottom'
import BorderTopIcon from '@material-ui/icons/BorderTop'
import BorderOuterIcon from '@material-ui/icons/BorderOuter'
import SelectAllIcon from '@material-ui/icons/SelectAll'
import SaveIcon from '@material-ui/icons/Save'
import TextFieldsIcon from '@material-ui/icons/TextFields'
import ImageIcon from '@material-ui/icons/Image'
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore'
import HeightIcon from '@material-ui/icons/Height'
import SlideshowIcon from '@material-ui/icons/Slideshow'
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation'
import MenuOpenIcon from '@material-ui/icons/MenuOpen'
import VideoLabelIcon from '@material-ui/icons/VideoLabel'
import EditIcon from '@material-ui/icons/Edit'
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined'
import ViewAgendaOutlinedIcon from '@material-ui/icons/ViewAgendaOutlined'

import TemporaryDrawer from '../drawers/Drawers'
import Inputs from '../inputs/Inputs'
import actions from '../../actions/Actions'

import Login from '../login/Login'
import Register from '../register/Register'

import NoteOutlinedIcon from '@material-ui/icons/NoteOutlined'
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined'

import './navigation.scss'

type NavigationState = {
  article: any;
  navigation: any;
  history: any;
  login: any;
  route: any;
}

type NavigationProps = {
  article: any;
  navigation: any;
  history: any;
  login: any;
  route: any;
}

class Navigation extends React.Component<NavigationState, NavigationProps> {
  
  constructor(props) {
    super(props)

    // console.log(props)

    this.state = {
      history: props.history,
      article: store.getState().article,
      navigation: store.getState().navigation,
      login: store.getState().login,
      route: store.getState().route
    }
  }

  componentDidMount() {
    // console.log('Navigation Did Mount')

    addEventListener('load', (event) => {
      actions.menuActions.setScreenWidth(window.screen.width)
      actions.menuActions.setScreenHeight(window.screen.height)
      actions.menuActions.setInnerWidth(window.innerWidth)
      actions.menuActions.setInnerHeight(window.innerHeight)
    })

    addEventListener('resize', (event) => {
      actions.menuActions.setScreenWidth(window.screen.width)
      actions.menuActions.setScreenHeight(window.screen.height)
      actions.menuActions.setInnerWidth(window.innerWidth)
      actions.menuActions.setInnerHeight(window.innerHeight)
    })

    store.subscribe(() => {
      this.setState({
        article: store.getState().article,
        navigation: store.getState().navigation,
        login: store.getState().login,
        route: store.getState().route
      })
    })
  }

  componentWillUnmount() {
    console.log('Navigation Will Unmount')

    store.subscribe(() => {
      this.setState({
        article: store.getState().article,
        navigation: store.getState().navigation
      })
    })
  }

  componentReceivedProps() {
    store.subscribe(() => {
      this.setState({
        article: store.getState().article,
        navigation: store.getState().navigation
      })
    }) 
  }

  redirect = (route) => {
    const { history } = this.state

    // console.log(history)

    actions.routeActions.changeRoute({
      route
    })

    history.push(route)
  }

  onMouseOverIcon = (event) => {
    // console.log(event)

    actions.navigationActions.changeIconHover(
      true
    )
  }

  onMouseOutIcon = (event) => {
    // console.log(event)

    actions.navigationActions.changeIconHover(
      false
    )
  }

  render () {
    let {
      article,
      navigation,
      login,
      route
    } = this.state

    // console.log(table)
    // console.log(navigation)

    return (
      <div
        className={ 'MainMenu' }
        style={{
          display: 'block',
          position: 'absolute',
          top: 0,
          right: 0,
          width: '100vw',
          height: '49px'
        }}
      >

        {
          !(!login.loggedIn || route.currentRoute === routes.ROUTE_OVERVIEW || route.currentRoute === routes.ROUTE_USER) ? (
            <div
              style={{
                display: 'block',
                width: '100vw',
                height: '49px'
              }}
            >
              <img 
                width='50px'
                height='49px'
                src={require('/public/logo.png')}
                alt=''
                style={{
                  display: 'inline-block',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  height: 'inherit',
                  lineHeight: '49px'
                }}
              />
              <div
                style={{
                  display: 'inline-block',
                  height: 'inherit',
                  lineHeight: '59px',
                  padding: '0 0 0 calc(50px + 30px)',
                  borderBottom: '1px solid black'
                }}
              >
                { article.info.name }
              </div>
            </div>
          ) : null
        }

        <div
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            margin: 1
          }}
        >

          {
            store.getState().route.currentRoute === routes.ROUTE_OVERVIEW ? (
              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={ this.redirect.bind(this, routes.ROUTE_ARTICLE) }
              >
                <Icon>
                  <AddBoxOutlinedIcon />
                </Icon>
              </IconButton>
            ) : null
          }

          {
            store.getState().route.currentRoute === routes.ROUTE_OVERVIEW ? (
              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={ this.redirect.bind(this, routes.ROUTE_USER) }
              >
                <Icon>
                  <PersonIcon />
                </Icon>
              </IconButton>
            ) : null
          }

          {
            store.getState().route.currentRoute === routes.ROUTE_USER ? (
              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={ this.redirect.bind(this, routes.ROUTE_OVERVIEW) }
              >
                <Icon>
                  <ViewAgendaOutlinedIcon />
                </Icon>
              </IconButton>
            ) : null
          }

          {
            store.getState().menu.activeLanguage === 1 ? (
              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color='inherit' 
                aria-label='menu'
                onClick={() => {
                  actions.menuActions.changeLanguage({
                    language: 0
                  })
                }}
                onMouseOver={ this.onMouseOverIcon.bind(this) }
                onMouseOut={ this.onMouseOutIcon.bind(this) }
              >
                <Icon>
                  <img
                    className={ 'germanIcon' }
                    style={{
                      padding: '0 0 2px 0'
                    }}
                    width='20px' 
                    height='20px'
                    src={ navigation.iconHover ? '/images/DE_155.png' : '/images/DE_230.png' }
                  />
                </Icon>
              </IconButton>
            ) : (                 
              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color='inherit' 
                aria-label='menu'
                onClick={() => {
                  actions.menuActions.changeLanguage({
                    language: 1
                  })
                }}
                onMouseOver={ this.onMouseOverIcon.bind(this) }
                onMouseOut={ this.onMouseOutIcon.bind(this) }
              >
                <Icon>
                  <img
                    className={ 'englishIcon' }
                    style={{
                      padding: '0 0 2px 0'
                    }}
                    width='20px' 
                    height='20px'
                    src={ navigation.iconHover ? '/images/EN_155.png' : '/images/EN_230.png' }
                  />
                </Icon>
              </IconButton>
            )
          }
            
        </div>
      </div>
    )
  }
}

export default withRouter(Navigation)